import { useMemo } from 'react'
import { AccountType } from '@/common/types'
import { useFetchTradingAccount } from '@/trading/tradingQueries'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { useUser } from '@/user/useUser'
import { buildAccountDetailItems } from './accountDetails'
import type { ActionableDetailItem } from '../types'

interface UseAccountDetailItemsProps {
    onAddTfn?: () => void
}

export function useAccountDetailItems({ onAddTfn }: UseAccountDetailItemsProps = {}): ActionableDetailItem[] {
    const account = useCurrentAccount()
    const user = useUser()

    const { data: tradingAccount } = useFetchTradingAccount(account?.accountId ?? null, {
        enabled: Boolean(account?.accountId) && account?.accountType !== AccountType.ADVISER,
    })

    const accountDetails = useMemo(
        () => buildAccountDetailItems(account, tradingAccount, user?.tfnProvided, onAddTfn),
        [account, tradingAccount, user?.tfnProvided, onAddTfn],
    )

    return accountDetails
}
